import { toast } from "sonner";

/**
 * Toetsaccount (sessie 77): de backend weigert elke schrijfactie van een
 * gebruiker met rol "toets" buiten de proefaccounts met HTTP 403 en
 * precies deze detail-tekst. De axios-interceptor (lib/api.ts) toont dan
 * één vaste melding; de generieke "Opslaan is niet gelukt" uit
 * query-client.ts komt er niet bovenop.
 */
export const TOETS_WEIGERING_DETAIL = "Toetsaccount: niet toegestaan";
export const TOETS_WEIGERING_UITLEG =
  "Deze actie kan alleen op een proefaccount.";

/** Vaste id: tien geweigerde klikken geven één toast, niet tien. */
export const TOETS_WEIGERING_TOAST_ID = "toetsaccount-weigering";

export function isToetsWeigering(fout: unknown): boolean {
  const antwoord = (
    fout as { response?: { status?: number; data?: { detail?: unknown } } }
  )?.response;
  return (
    antwoord?.status === 403 && antwoord.data?.detail === TOETS_WEIGERING_DETAIL
  );
}

/** De tekst die vertaalApiFout voor een toets-weigering teruggeeft. */
export const TOETS_WEIGERING_TEKST = `${TOETS_WEIGERING_DETAIL}. ${TOETS_WEIGERING_UITLEG}`;

let dedupeGeinstalleerd = false;

/**
 * Veel schermen tonen bij een fout zelf `toast.error(vertaalApiFout(e))`.
 * Bij een toets-weigering zou dat een tweede melding naast die van de
 * axios-laag geven. Eenmalig bij de start: een foutmelding met de
 * toets-tekst krijgt dezelfde vaste id, zodat sonner er één van maakt.
 */
export function installeerToetsToastDedupe(): void {
  if (dedupeGeinstalleerd) return;
  dedupeGeinstalleerd = true;
  const origineel = toast.error;
  toast.error = ((bericht, opties) =>
    bericht === TOETS_WEIGERING_TEKST || bericht === TOETS_WEIGERING_DETAIL
      ? origineel(TOETS_WEIGERING_DETAIL, {
          ...opties,
          id: TOETS_WEIGERING_TOAST_ID,
          description: TOETS_WEIGERING_UITLEG,
        })
      : origineel(bericht, opties)) as typeof toast.error;
}

export function meldToetsWeigering(): void {
  toast.error(TOETS_WEIGERING_DETAIL, {
    id: TOETS_WEIGERING_TOAST_ID,
    description: TOETS_WEIGERING_UITLEG,
  });
}
